<template>
    <div class="k-mod-view-one ">
        <slot name="left-icon">
            <k-icon name="star" size="0.6rem" color="#613B3A" class="k-mod-view--leftIcon" />
        </slot>
        <div class="k-mod-view--title">{{title || ""}}</div>
        <div class="k-mod-view--des">{{des || ""}}</div>
    </div>
</template>

<script>
    export default {
        name: "k-view-one",
        props:["title","des"]
    }
</script>

<style lang="less" scoped>
    .k-mod-view-one {
        padding: 0.3rem;
        .k-mod-view--title {
            font-size: 0.3rem;
            line-height: 1.6;
            color: #2a2a2a;
        }
        .k-mod-view--des {
            font-size: 0.24rem;
            color: #bbb;
        }
        .k-mod-view--leftIcon {
            float: left;
            margin-right: 0.1rem;
        }
    }
</style>